<template>
    <div class="login-page">
        <div class="login-logo" @click="toIndexPage">
            <img src="../../assets/mall_logo.png" alt="云仓商城" title="云仓商城">
        </div>
        
        <!-- <br><br><br><br>
        <router-link to="/supplier">供应商</router-link> <br>
        <router-link to="/dealer">销售商</router-link> -->

        <div class="login-wrap">
            <div class="login-tit">云仓商城</div>
            <div class="login-tit-en">Cloud Mall</div>
            <div class="login-box">
                <div class="tab">
                    <span class="item" :class="{act: tab==1}" @click="switchTab(1)">验证码登录</span>
                    <span class="item" :class="{act: tab==2}" @click="switchTab(2)">密码登录</span>
                </div>
                
                    <div class="form-box" v-show="tab==1">
                        <el-form @submit.native.prevent @keyup.enter.native="submit1">
                            <div class="login-input" :class="{err: ruleForm1.phone.validate == 'error'}">
                                <input class="input-inner" type="text" placeholder="请输入手机号" v-model.trim="form1.phone" 
                                    @input="validatePhone1('input')"
                                >
                                <span class="lab">手机号</span>
                                <div class="err-tip" v-show="ruleForm1.phone.validate == 'error'">{{ruleForm1.phone.errText}}</div>
                            </div>
                            <div class="login-input" :class="{err: ruleForm1.code.validate == 'error'}">
                                <input class="input-inner code" type="text" placeholder="请输入验证码" v-model.trim="form1.code"
                                    @input="validateCode1('input')"
                                >
                                <span class="lab">验证码</span>
                                <span class="sent-code" @click="sentCodeHandle">{{sentCodeText}}</span>
                                <div class="err-tip" v-show="ruleForm1.code.validate == 'error'">{{ruleForm1.code.errText}}</div>
                            </div>
                            <div class="btn-wrap">
                                <button class="login-btn" :class="{opa: loading}" @click="submit1"><i class="el-icon-loading" v-show="loading"></i> 登录</button>
                            </div>
                        </el-form>
                    </div>
                    <div class="form-box" v-show="tab==2">
                        <el-form @submit.native.prevent @keyup.enter.native="submit2">
                            <div class="login-input" :class="{err: ruleForm2.phone.validate == 'error'}">
                                <input class="input-inner" type="text" placeholder="请输入手机号" v-model.trim="form2.phone" 
                                    @input="validatePhone2('input')"
                                >
                                <span class="lab">手机号</span>
                                <div class="err-tip" v-show="ruleForm2.phone.validate == 'error'">{{ruleForm2.phone.errText}}</div>
                            </div>
                            <div class="login-input" :class="{err: ruleForm2.passWd.validate == 'error'}">
                                <input class="input-inner" type="password" placeholder="请输入密码" v-model.trim="form2.passWd"
                                    @input="validateCode2('input')"
                                >
                                <span class="lab">密码</span>
                                <span class="forget-secret" @click="toForgetPassword">忘记密码?</span>
                                <div class="err-tip" v-show="ruleForm2.passWd.validate == 'error'">{{ruleForm2.passWd.errText}}</div>
                            </div>
                            <div class="btn-wrap">
                                <button class="login-btn" :class="{opa: loading}" @click="submit2"><i class="el-icon-loading" v-show="loading"></i> 登录</button>
                            </div>
                        </el-form>
                    </div>
                
            </div>
        </div>
    </div>
</template>

<script>
import { PhoneNumberLoginOrRegiste, RequestPhoneCode, RequestAccountPasswdLogin } from '../../api/public'
import { validateMobile } from '../../utils/validate'
import { cookiesList, setCookie} from '../../utils/cookies'
import { mapGetters } from 'vuex'
export default {
    data() {
        return {
            tab: 1, // 1 - 验证码登录  2 - 密码登录
            loading: false, // 提交loading

            // 验证码相关
            sentCodeBtn: true,
            sentCodeText: '发送验证码',
            sentCodeTimer: null,

            // 手机号验证码登录
            form1: {
                phone: '',
                code: ''
            },
            ruleForm1: {
                phone: {
                    validate: '',
                    errText: ''
                },
                code: {
                    validate: '',
                    errText: ''
                }
            },
            form2: {
                phone: '',
                passWd: ''
            },
            ruleForm2: {
                phone: {
                    validate: '',
                    errText: ''
                },
                passWd: {
                    validate: '',
                    errText: ''
                }
            }
        }
    },
    computed: {
        ...mapGetters(['merchantId']),
    },
    methods: {
        switchTab(tab) {
            this.tab = tab
        },
        submit() {
            if (this.loading) return;
            this.loading = true
            setTimeout(() => {
                this.loading = false
                this.$router.push('/supplier')
            }, 800)
        },
        validateForm1() {
            let validatePhone = this.validatePhone1()
            let validateCode = this.validateCode1()
            if (validatePhone && validateCode) {
                return true
            } else {
                return false
            }
        },
        validatePhone1 (type) {
            if (type == 'input' && this.ruleForm1.phone.validate == '') return 
            if (this.form1.phone == '') {
                this.ruleForm1.phone.validate = 'error'
                this.ruleForm1.phone.errText = '请输入手机号'
                return false
            }
            if (!validateMobile(this.form1.phone)) {
                this.ruleForm1.phone.validate = 'error'
                this.ruleForm1.phone.errText = '手机号格式不合法'
                return false
            }
            this.ruleForm1.phone.validate = 'success'
            this.ruleForm1.phone.errText = '校验通过'
            return true
        },
        validateCode1 (type) {
            if (type == 'input' && this.ruleForm1.code.validate == '') return
            if (this.form1.code == '') {
                this.ruleForm1.code.validate = 'error'
                this.ruleForm1.code.errText = '请输入验证码'
                return false
            }
            this.ruleForm1.code.validate = 'success'
            this.ruleForm1.code.errText = '校验通过'
            return true
        },
        submit1() {
            if (this.loading) return
            if (this.validateForm1()) {
                console.log('validate success')
                this.loading = true
                PhoneNumberLoginOrRegiste({
                    phone: this.form1.phone,
                    code: this.form1.code
                }).then(res => {
                    this.loading = false
                    // console.log(res)
                    if (res.errorCode == 200) {
                        if (res.data.type == '2') {
                            this.$store.dispatch('setLoginInfo', {
                                ...res.data,
                                account: res.data.account || this.form1.phone
                            })
                            if (res.data.hasPwd == 'true') {
                                setCookie(cookiesList.has_password, 'true')
                            } else {
                                setCookie(cookiesList.has_password, 'false')
                            }
                            this.$notify({
                                title: '登录成功',
                                message: '',
                                type: 'success',
                                duration: '2500'
                            });
                            let redirectUrl = this.$route.query.redirect || ''
                            this.$router.push(redirectUrl || '/dealer/index?mid=' + this.merchantId);
                        } else {
                            this.$message.error('该用户不是销售商，请联系管理员进行设置')
                        } 
                    } else {
                        this.$message.error(res.errorMsg || '登录异常')
                    }
                }).catch(err => {
                    this.loading = false
                    console.log(err)
                })
            } else {
                console.log('validate fail')
            }
        },
        // 获取验证码
        sentCodeHandle() {
            if (this.sentCodeBtn) {
                if (!this.validatePhone1()) return
                RequestPhoneCode(this.form1.phone).then(res => {
                    console.log(res)
                    if (res.errorCode == 200) {
                        this.$message.success('验证码发送成功')

                        this.sentCodeBtn = false
                        let t = 60
                        this.sentCodeText = t + 's'
                        clearInterval(this.sentCodeTimer)
                        this.sentCodeTimer = setInterval(() => {
                            if (t > 0) {
                                t --
                                this.sentCodeText = t + 's'
                            } else {
                                this.sentCodeText = '获取验证码'
                                this.sentCodeBtn = true
                                clearInterval(this.sentCodeTimer)
                            }
                        }, 1000)
                        
                    } else if (res.errorCode == -10111) { // 账号不存在
                        this.$message.error(res.errorMsg || '验证码发送失败')
                    } else {
                        this.$message.error(res.errorMsg || '验证码发送失败')
                    }
                }).catch(err => {
                    console.log(err)
                })
                
            }
        },
        toForgetPassword() {
            this.$router.push('/forget-password')
        },
        validateForm2() {
            let validatePhone = this.validatePhone2()
            let validateCode = this.validateCode2()
            if (validatePhone && validateCode) {
                return true
            } else {
                return false
            }
        },
        validatePhone2 (type) {
            if (type == 'input' && this.ruleForm2.phone.validate == '') return 
            if (this.form2.phone == '') {
                this.ruleForm2.phone.validate = 'error'
                this.ruleForm2.phone.errText = '请输入手机号'
                return false
            }
            if (!validateMobile(this.form2.phone)) {
                this.ruleForm2.phone.validate = 'error'
                this.ruleForm2.phone.errText = '手机号格式不合法'
                return false
            }
            this.ruleForm2.phone.validate = 'success'
            this.ruleForm2.phone.errText = '校验通过'
            return true
        },
        validateCode2 (type) {
            if (type == 'input' && this.ruleForm2.passWd.validate == '') return
            if (this.form2.passWd == '') {
                this.ruleForm2.passWd.validate = 'error'
                this.ruleForm2.passWd.errText = '请输入密码'
                return false
            }
            this.ruleForm2.passWd.validate = 'success'
            this.ruleForm2.passWd.errText = '校验通过'
            return true
        },
        submit2() {
            if (this.loading) return
            if (this.validateForm2()) {
                console.log('validate success')
                this.loading = true
                RequestAccountPasswdLogin({
                    phone: this.form2.phone,
                    passWd: this.form2.passWd
                }).then(res => {
                    this.loading = false
                    // console.log(res)
                    if (res.errorCode == 200) {
                        if (res.data.type == '2') {
                            this.$store.dispatch('setLoginInfo', {
                                ...res.data,
                                account: res.data.account || this.form2.phone
                            })
                            if (res.data.hasPwd == 'true') {
                                setCookie(cookiesList.has_password, 'true')
                            } else {
                                setCookie(cookiesList.has_password, 'false')
                            }
                            this.$notify({
                                title: '登录成功',
                                message: '',
                                type: 'success',
                                duration: '2500'
                            });
                            let redirectUrl = this.$route.query.redirect || ''
                            console.log(redirectUrl)
                            this.$router.push(redirectUrl || '/dealer/index?mid=' + this.merchantId);
                        } else {
                            this.$message.error('该用户不是销售商，请联系管理员进行设置')
                        } 
                    } else {
                        this.$message.error(res.errorMsg || '登录异常')
                    }
                }).catch(err => {
                    this.loading = false
                    console.log(err)
                })
            } else {
                console.log('validate fail')
            }
        },
        toIndexPage() {
            this.$router.push('/dealer/index?mid=' + this.merchantId)
        }
    }
}
</script>

<style lang="scss" scoped>
.login-page {
    position: absolute;
    top: 0; left: 0; right: 0; bottom: 0;
    background: url(../../assets/login_bg.jpg) no-repeat center center;
    background-size: cover;
    .login-logo {
        margin: 40px 0 0 82px;
        width: 142px; height: 36px;
        cursor: pointer;
        img {
           width: 142px; height: 36px; display: block; 
        }
    }
    .login-wrap {
        position: absolute; left: 50%; top: 50%;
        width: 460px; height: 490px;
        margin: -265px 0 0 100px;
        .login-tit {
            height:50px;
            font-size:36px;
            font-weight:600;
            color:rgba(42,46,63,1);
            line-height:50px;
            letter-spacing:2px;
        }
        .login-tit-en {
            height:25px;
            font-size:18px;
            font-weight:500;
            color:rgba(153,153,153,1);
            line-height:25px;
            letter-spacing:1px;
        }
        .login-box {
            margin-top: 32px;
            width:460px;
            height:370px;
            background:rgba(255,255,255,1);
            box-shadow:-2px 2px 14px 6px rgba(0,0,0,0.05);
            border-radius:6px;
            box-sizing: border-box;
            padding: 40px 45px 0;
        }
        .tab {
            text-align: center;
            .item {
                margin: 0 34px;    
                display: inline-block;
                height:28px;
                font-size:20px;
                font-weight:500;
                color:rgba(42,46,63,1);
                line-height:28px;
                letter-spacing:1px;
                position: relative;
                cursor: pointer;
                &.act::after {
                    content: ' ';
                    position: absolute;
                    left: 10px; right: 10px; bottom: -8px;
                    height: 2px; background: #2A2E3F;
                }
            }
            
        }
    }
    .form-box {
        padding-top: 40px;
        .login-input {
            height: 44px;
            margin-bottom: 24px;
            position: relative;
        }
        .input-inner {
            width: 100%;
            height: 44px;
            border: 1px solid #E7E7E7;
            font-size: 14px;
            color: #2A2E3F;
            outline: none;
            box-sizing: border-box;
            padding-left: 100px;
            padding-right: 16px;
            &.code {padding-right: 120px;}
        }
        .login-input.err .input-inner {
            border-color: #f56c6c;
        }
        .err-tip {
            position: absolute;
            left: 0; top: 44px;
            color: #f56c6c;
            font-size: 12px;
        }
        .lab {
            position: absolute; left: 0; top: 7px;
            height: 30px; width: 80px;
            line-height: 30px;
            font-size: 14px;
            color: #2A2E3F;
            border-right: 1px solid #E7E7E7;
            text-align: center;
        }
        .forget-secret {
            position: absolute; top: 50px; right: 0;
            height:18px;
            font-size:12px;
            color:rgba(42,46,63,1);
            line-height:18px;
            cursor: pointer;
            &:hover {
                text-decoration: underline;
            }
        }
        .sent-code {
            position: absolute; right: 10px; top: 8px;
            height:30px;
            padding: 0 16px;
            background:rgba(247,247,247,1);
            border-radius:16px;
            font-size:12px;
            color:rgba(51,51,51,1);
            line-height:30px;
            cursor: pointer;
        }
        .btn-wrap {
            margin-top: 50px;
            .login-btn {
                width: 100%;
                height:42px;
                background:rgba(225,16,16,1);
                border-radius:2px;
                font-size:20px;
                font-weight: normal;
                color:rgba(255,255,255,1);
                letter-spacing:1px;
                border: none;
                outline: none;
                &.opa {opacity: 0.6;}
            }
        }
        
    }

}
</style>